const MUR = new Intl.NumberFormat('en-MU', {
  style: 'currency',
  currency: 'MUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const MUR_NO_SYMBOL = new Intl.NumberFormat('en-MU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMUR(value: number | string | null | undefined): string {
  if (value == null || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(n)) return '—';
  return MUR.format(n);
}

export function formatNumber(value: number | string | null | undefined): string {
  if (value == null || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(n)) return '—';
  return MUR_NO_SYMBOL.format(n);
}
